import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Col from 'react-bootstrap/lib/Col';
// import * as DashBoardActionType from '../constants';
import Skeleton, {SkeletonTheme} from 'react-loading-skeleton';
import isNumber from 'lodash/isNumber';
import isNaN from 'lodash/isNaN';
class KeyMetrics extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    DashBoardStore: PropTypes.object,
    location: PropTypes.object,
    history: PropTypes.object,
    KeyMetricsProfile: PropTypes.object,
    loading: PropTypes.bool,
    getKeyMetrics: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      isLoading: this.props.loading
    };
  }

  componentDidMount() {
    this.props.getKeyMetrics({}, setTimeout(() => this.setState({isLoading: true}), 500));
  }

  onViewAwaitingReview = () => {
    this.props.history.push('/work-order-list?Status=0&skip=1&sortField=refNo&sortOrder=descending&take=10');
  }

  onViewRequestToReopen = () => {
    this.props.history.push('/work-order-list?Status=6&skip=1&sortField=refNo&sortOrder=descending&take=10');

  }

  onViewPending = () => {
    this.props.history.push('/work-order-list?Status=2&skip=1&sortField=refNo&sortOrder=descending&take=10&Type=2');
  }

  onViewRFSStatus = () => {
    this.props.history.push('/request-for-services?Status=&skip=1&sortField=refNo&sortOrder=descending&take=10&NewRFSFilterFromTiles=True');
  }

  renderSkeleton = () => {
    return (
      <SkeletonTheme color='#efe6e6'>
        <section>
          <Col xs={12} sm={12} md={6} lg={3}>
            <Skeleton count={1} style={{ height: 100, margin: '5px 0' }} />
          </Col>
          <Col xs={12} sm={12} md={6} lg={3}>
            <Skeleton count={1} style={{ height: 100, margin: '5px 0' }} />
          </Col>
          <Col xs={12} sm={12} md={6} lg={3}>
            <Skeleton count={1} style={{ height: 100, margin: '5px 0' }} />
          </Col>
          <Col xs={12} sm={12} md={6} lg={3}>
            <Skeleton count={1} style={{ height: 100, margin: '5px 0' }} />
          </Col>
        </section>
      </SkeletonTheme>
    );
  }

  renderKeyMetrics = () => {
    const {averageAge, awaitingReview, pending, requestToReopen,unAssignedNewRfsCount} = this.props.KeyMetricsProfile;
    const convertAverageAge = (Math.round(averageAge * 100) / 100).toFixed(1);
    return (
      <React.Fragment>
        <Col onClick={this.onViewAwaitingReview} xs={12} sm={6} md={12} lg={3} className='box-dashboard-information awaiting-review'>
          <h2 className='margin-left-25 card-title'>{isNumber(awaitingReview) ? awaitingReview : '-'}</h2>
          <p className='margin-left-25 card-text'>Awaiting review</p>
        </Col>
        <Col onClick={this.onViewRequestToReopen} xs={12} sm={6} md={12} lg={3} className='box-dashboard-information request-to-reopen'>
          <h2 className='margin-left-25 card-title'>{isNumber(requestToReopen) ? requestToReopen : '-'}</h2>
          <p className='margin-left-25 card-text'>Request to reopen</p>
        </Col>
        <Col onClick={this.onViewPending} xs={12} md={12} sm={6} lg={3} className='box-dashboard-information pending-metrics'>
          <h2 className='margin-left-25 card-title'>{isNumber(pending) ? pending : '-'}</h2>
          <p className='margin-left-25 card-text'>Pending</p>
        </Col>
        <Col xs={12} md={12} sm={12} lg={12} className='box-dashboard-information average-age'>
          <h2 className='margin-left-25 card-title'>{!isNaN(convertAverageAge) ? convertAverageAge : '-'}</h2>
          <p className='margin-left-25 card-text'>Average age</p>
        </Col>
        <Col onClick={this.onViewRFSStatus} xs={12} md={12} sm={12} lg={12} className='box-dashboard-information average-age'>
          <h2 className='margin-left-25 card-title'>{isNumber(unAssignedNewRfsCount) ? unAssignedNewRfsCount : '-'}</h2>
          <p className='margin-left-25 card-text'>New RFS</p>
        </Col>
      </React.Fragment>
    );
  }

  render() {
    const {isLoading} = this.state;
    return (
      <React.Fragment>
        {isLoading === false ? this.renderSkeleton() : this.renderKeyMetrics()}
      </React.Fragment>

    );
  }
}

export default KeyMetrics;



// WEBPACK FOOTER //
// ./src/Dashboard/Components/key-metrics.js